<template>
    <div class="badge">
        <gtheader></gtheader>
        <div class="card">
            <div class="left">
                <label for="name">姓名 <input type="text" id="name" v-model="user.name" autocomplete="off" placeholder="请输入内容"></label>
                <label for="english"> 英文名(选填)<input type="text" id="english" v-model="user.english_name" placeholder="请输入内容"></label>
                <label for="position">工号 <input type="text" id="position" v-model="user.num"></label> 
                <div @click="upload = true" class="btn-normal upload-btn">上传图片</div>
                 <div class="btn-normal" @click="downloadImg">下载工牌图片</div>
            </div>
            <div class="right">
                <div class="right-inner" id="badge">
                    <div class="upload-img" @click="upload = true">
                        <img :src="img" alt="">
                        <gtUpload filed="img" v-model="upload" @crop-success="cropSuccess" img-format="png" :noSquare="true"
                        :width="286" :height="286"></gtUpload>
                    </div>
                    <div class="name">
                        <span>{{user.name}}</span>
                    </div>
                    <div class="english">
                        <span>{{user.english_name}}</span>
                    </div>

                    <div class="num">
                      <span> NO.{{user.num}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div id="test">
            <span>sdfadsf</span>
             <div class="num">
                <span>NO.{{user.num}}</span>
            </div>
        </div> -->
    </div>
</template>
<script>
import gtheader from 'components/header'
import gtUpload from 'vue-image-crop-upload';
import img from '@/assets/img/preImg.png';
import html2canvas from 'html2canvas'
export default {
    components:{gtUpload, gtheader},
    data(){
        return{
            upload:false,
            img:img,
            user:{name:'', english_name:'', num:'000'}
        }
    },
    methods:{
        cropSuccess(e){
            this.img = e;
            this.upload = false;
        },
        downloadImg(){
             const _canvas =  document.getElementById("badge");
             // 此处用于解决截图不清晰问题，将生成的canvas放大，然后再填充到原有的容器中就会清晰
              const width = _canvas.offsetWidth; 
              const height = _canvas.offsetHeight; 
              const canvas2 = document.createElement('canvas');
              const scale = 2;
              canvas2.width = width * scale;
              canvas2.height = height * scale;
              canvas2.style.width = width + "px";
              canvas2.style.height = height + "px";
              const context1 = canvas2.getContext('2d')
              let ret = _canvas.getBoundingClientRect()
              if(context1) {
                context1.scale(scale, scale);
                context1.translate(-ret.left,-ret.top)
              }
              const opts = {
                    scale,
                    canvas: canvas2,
                    width,
                    height,
                    useCORS: true ,
                    dpi: window.devicePixelRatio*2
                 }
            html2canvas(_canvas,opts).then((canvas) => {
                  const context = canvas2.getContext('2d');
                //   document.body.appendChild(canvas)
                  if(context) {
                      context.scale(2,2);
                      context.mozImageSmoothingEnabled = false;
                      context.webkitImageSmoothingEnabled = false;
                      context.imageSmoothingEnabled = false;
                  }
                  // canvas转换成url，然后利用a标签的download属性，直接下载，绕过上传服务器再下载
                const preview = canvas.toDataURL(
                      {
                        format:'png',
                        encoderOptions:1,
                        })
                 const link = document.createElement('a');
                    link.href = preview;
                    link.setAttribute('download', `${this.user.name}-工牌正面.png`);
                    document.body.appendChild(link);
                    link.click();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.badge{
    background-image: url('../assets/img/badge-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    
}
.card{
    display: inline-flex;
    min-width: 1270px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    label{
        display: block;
        text-align: left;
        margin-bottom: 25px;
        color: #292F3A;
        input{
            display: block;
            margin-top: 6px;
            padding: 6px;
            border-radius: 3px;
            border: 1px solid #C0C4CC;
        }
        input:focus{
            outline: none;
        }
    }
    .left{
        box-shadow: 0 18px 30px 0 rgba(44,71,146,0.32);
        padding: 24px 16px;
        font-size: 12px;
        margin-right: 32px;
        height: 100%;
    }
}
.right{
    background-image: url('../assets/img/cover.png');
    background-repeat: no-repeat;
    width: 732px;
    height:1160px;
    background-size:cover;
    position: relative;
    color: white;
    .right-inner{
        background-image: url('../assets/img/cover-inner.png');
        width: 608px;
        height:956px;
        background-size:cover;
        margin-top: 140px;
        margin-left: 63px;
        position: relative;
    }
    .upload-img{
        // background-image: url('../assets/img/preImg.png');
        width: 286px;
        height: 286px;
        position: absolute;
        top:114px;
        left: 164px;
        cursor: pointer;
       img{
         border-radius: 50%
       }
    }
    .name{
        position: absolute;
        top:452px;
        color: #292F3A;
        font-size: 67.2px;
        font-weight: 600;
        width: 100%;
        text-align: center
    }
    .english{
        color: #292F3A;
        font-weight: 300;
        position: absolute;
        top:588px;
        width: 100%;
        text-align: center;
        font-size: 35.2px;
    }
    .num{
        color: #292F3A;
        font-weight: 300;
        position: absolute;
        top:712px;
        width: 100%;
        text-align: center;
        font-size: 28px;
        display: flex;
        height: 48px;
        line-height: 48px;
        justify-content: center;
        span{
            background: #357DFF;
            color: white;
            border-radius: 3px;
            padding: 1px 6px 3px;
            margin: 0;
            display: flex;
            line-height: 38px;
        }
    }
}
 .upload-btn{
    margin-bottom: 20px;
}

</style>

